var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title:
          _vm.$t("CargoMsg.Cargo_Box") + "-" + _vm.$t("CargoMsg.Cargo_Edit"),
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "show-close": false,
        "modal-append-to-body": false,
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px", height: "100%" } },
        [
          _c("div", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v(_vm._s(_vm.totalLabel))
          ]),
          _c(
            "div",
            {
              staticStyle: {
                float: "right",
                "margin-bottom": "5px",
                "margin-top": "5px"
              }
            },
            [
              _c(
                "el-button",
                { attrs: { no: "1", type: "primary" }, on: { click: _vm.add } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "2", type: "danger" }, on: { click: _vm.del } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
              )
            ],
            1
          ),
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              no: "3",
              "config-module": "150020",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "3", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }